import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { projectService, userService } from '../services';
import { setAllProjectsGlobal, StageTypes, openNotification } from '../utils';
import {
  getCurrentCompany,
  getCurrentProject,
  getCurrentSector
} from '../utils/userUtils';
import { trackingEvent } from '../analytics';
import * as projectActions from '../redux/slices/projectSlice';

export const useProjectActions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const projectState = useSelector((state) => state.projectState);
  const user = JSON.parse(localStorage.getItem('user'));
  const currentProject = getCurrentProject();
  const currentSector = getCurrentSector();

  const unarchiveProject = async (project) => {
    const response = await projectService.update({
      ...project,
      stage: StageTypes.STARTED,
      archivereason: null
    });

    trackActionEvent(project, 'project_unarchiving_attempt', {
      event_result: response ? 'Success' : 'Fail'
    });

    if (!response) {
      openNotification({
        title: t('project_unarchive.error_message'),
        type: 'error'
      });

      return;
    }

    const projectsActive = await getActiveProjects();

    setAllProjectsGlobal(
      projectsActive,
      dispatch,
      projectActions,
      projectState
    );

    openNotification({
      title: t('project_unarchive.success_message'),
      type: 'success'
    });
  };

  const getActiveProjects = async () => {
    const getProjects = await userService.projectsbyuserthrough(user.id);
    return getProjects.projects.filter((e) => e.stage !== 'deleted');
  };

  const trackActionEvent = (project, eventName, eventProperties) => {
    const company = getCurrentCompany();
    trackingEvent(eventName, {
      organization_name: company.name,
      organization_id: company.id,
      project_name: project.name,
      project_id: project.id,
      ...eventProperties
    });
  };

  return {
    unarchiveProject,
    currentProject,
    currentSector
  };
};
